import { useMemo as f } from "react";
import { getColorNotice as l } from "../../../TextInput/TextInput.styled.js";
import { useMultiSelectContext as p } from "../MultiSelectContext.js";
import { FontAwesomeIconsPartooUsed as o } from "../../../../types/components/icon.js";
const I = ({
  canReset: r,
  error: n,
  warning: c,
  success: i,
  showMenu: t
}) => {
  const {
    readOnly: a
  } = p(), e = f(() => r && !a ? o.faCircleXmark : t ? o.faCaretUp : o.faCaretDown, [t, r]), m = l({
    error: n,
    warning: c,
    success: i
  }), s = e === o.faCircleXmark ? "secondary" : m;
  return {
    displayIcon: e,
    iconCaretColor: s
  };
};
export {
  I as useDropdownIndicator
};
